var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirplaneClockCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M 16 9 C 15.09 9 14.23 9.18 13.43 9.5 L 12.73 6.450001 L 16.620001 2.559999 C 17.200001 2 17.200001 1.030001 16.620001 0.440001 C 16.040001 -0.15 15.08 -0.146 14.5 0.440001 L 10.61 4.33 L 1.41 2.209999 L 0 3.619999 L 7.43 7.5 L 3.54 11.4 L 1.06 11.05 L 0 12.11 L 3.18 13.87 L 4.95 17.059999 L 6 16 L 5.66 13.5 L 9.55 9.63 L 10.57 11.59 C 9.59 12.79 9 14.33 9 16 C 9 19.870001 12.13 23 16 23 C 19.870001 23 23 19.870001 23 16 C 23 12.13 19.870001 9 16 9 M 16 21 C 13.24 21 11 18.76 11 16 C 11 13.24 13.24 11 16 11 C 18.76 11 21 13.24 21 16 C 21 18.76 18.76 21 16 21 M 16.5 16.25 L 16.5 12 L 15 12 L 15 17 L 18.610001 19.16 L 19.360001 17.940001 L 16.5 16.25 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M 20.999981 10.999983 L 11 22"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplaneClockCancel);
export default __webpack_public_path__ + "static/media/airplane-clock-cancel.e70ee78b.svg";
export { ForwardRef as ReactComponent };